var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _g, _rect23, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg20UpdatedNewTableArrived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 68,
    viewBox: "0 0 131 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.90234,
    y: 35.7422,
    width: 114.839,
    height: 24.5161,
    rx: 2.58065,
    fill: "#009823"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.709,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3223,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.9355,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.1602,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7734,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3867,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106.611,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5469,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 13.709,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3223,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36.9355,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 60.1602,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7734,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3867,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 106.611,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5469,
    y: 62.8389,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.160156,
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#009823"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 125.32,
    y: 42.8389,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#009823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_4449",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 17,
    height: 16
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5469,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "url(#pattern0_190_4449)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_4449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5469,
    y: 40.2583,
    width: 15.4839,
    height: 15.4839,
    fill: "white"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 64.0312,
    y: 38.3228,
    width: 18.0645,
    height: 19.3548,
    rx: 2.58065,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6477 51.5V50.7568V50.3748C66.6477 49.9963 66.7182 49.6695 66.8593 49.3942C67.0004 49.1155 67.1862 48.8746 67.4167 48.6716C67.6507 48.4652 67.9053 48.2845 68.1806 48.1297C68.4593 47.9748 68.738 47.8286 69.0167 47.691C69.2954 47.5533 69.55 47.4157 69.7806 47.2781C70.0146 47.137 70.2021 46.9804 70.3432 46.8084C70.4842 46.6363 70.5548 46.4333 70.5548 46.1994C70.5548 45.9 70.4498 45.6557 70.2399 45.4665C70.0335 45.2772 69.7496 45.1826 69.3883 45.1826C69.0133 45.1826 68.695 45.291 68.4335 45.5077C68.172 45.7245 68.0103 46.0514 67.9483 46.4884H66.5083C66.5152 46.0135 66.6253 45.5834 66.8386 45.1981C67.0554 44.8092 67.3789 44.5013 67.809 44.2742C68.2391 44.0471 68.7793 43.9335 69.4296 43.9335C69.987 43.9335 70.467 44.0282 70.8696 44.2174C71.2756 44.4067 71.5888 44.6699 71.809 45.0071C72.0292 45.3443 72.1393 45.7383 72.1393 46.189C72.1393 46.5641 72.0705 46.8875 71.9328 47.1594C71.7952 47.4312 71.6128 47.6634 71.3857 47.8561C71.1586 48.0488 70.9092 48.2174 70.6374 48.3619C70.3655 48.5065 70.0937 48.6406 69.8219 48.7645C69.5535 48.8884 69.3057 49.0157 69.0786 49.1465C68.8515 49.2738 68.6692 49.4183 68.5315 49.58C68.3939 49.7417 68.3251 49.9361 68.3251 50.1632V50.2303H72.129V51.5H66.6477ZM75.9511 51.6135C75.0461 51.6135 74.339 51.2849 73.8298 50.6277C73.324 49.9705 73.0711 49.0243 73.0711 47.789C73.0711 46.9632 73.1881 46.263 73.422 45.6884C73.656 45.1138 73.9881 44.6785 74.4182 44.3826C74.8483 44.0832 75.3592 43.9335 75.9511 43.9335C76.8388 43.9335 77.539 44.2656 78.0517 44.9297C78.5644 45.5903 78.8207 46.5417 78.8207 47.7839C78.8207 49.0191 78.5678 49.9671 78.062 50.6277C77.5562 51.2849 76.8526 51.6135 75.9511 51.6135ZM75.9511 50.38C76.3949 50.38 76.7201 50.1822 76.9265 49.7865C77.133 49.3873 77.2362 48.7215 77.2362 47.789C77.2362 46.8359 77.1313 46.1529 76.9214 45.74C76.7115 45.3271 76.3863 45.1206 75.9459 45.1206C75.5055 45.1206 75.1769 45.3288 74.9601 45.7452C74.7468 46.1615 74.6401 46.8428 74.6401 47.789C74.6401 48.7181 74.7468 49.3822 74.9601 49.7813C75.1734 50.1804 75.5038 50.38 75.9511 50.38Z",
    fill: "#009823"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_190_4449",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_190_4449",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_190_4449",
    width: 512,
    height: 512,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20UpdatedNewTableArrived);
export default __webpack_public_path__ + "static/media/20-updated-new-table-arrived.7ac94c6a375c96b5660222aca323025b.svg";
export { ForwardRef as ReactComponent };